import { createFileRoute, Outlet, redirect, isRedirect } from "@tanstack/react-router";
import { supabase } from "@/integrations/supabase/client";
import { checkTotpSessionRequired } from "@/lib/totp.functions";

export const Route = createFileRoute("/_authenticated")({
  ssr: false,
  beforeLoad: async ({ location }) => {
    const { data, error } = await supabase.auth.getUser();
    if (error || !data.user) {
      throw redirect({ to: "/auth" });
    }

    // Enforce confirmed email. OAuth users (e.g. Google) come back with
    // email_confirmed_at set automatically; password signups must click
    // the confirmation link before reaching any protected page.
    if (!data.user.email_confirmed_at && !data.user.confirmed_at) {
      await supabase.auth.signOut();
      throw redirect({ to: "/auth", search: { verify: "pending" } as never });
    }


    // Enforce TOTP once per sign-in session. If the user enrolled 2FA but
    // their current session has not satisfied a TOTP challenge yet, bounce
    // them to /auth for the second factor before they reach any
    // protected page (covers session restores, signups without 2FA gate,
    // and direct URL access).
    try {
      const { required } = await checkTotpSessionRequired();
      if (required) {
        throw redirect({
          to: "/auth",
          search: { redirect: location.href } as never,
        });
      }
    } catch (err) {
      // Re-throw redirects; swallow transient errors so the gate stays
      // permissive when the TOTP check itself fails (network blip, etc.).
      if (isRedirect(err)) throw err;
    }
    return { user: data.user };
  },
  component: () => <Outlet />,
});
